<template>
  <el-menu
    :default-active="$route.path"
    router
    :unique-opened="true"
    background-color="#304156"
    text-color="#bfcbd9"
    active-text-color="#409EFF"
  >
    <template v-for="item in menuTree">
      <!-- 如果有子菜单，渲染为 el-submenu -->
      <el-submenu v-if="item.children && item.children.length" :key="item.id" :index="item.path || item.name">
        <template slot="title">
          <i :class="item.icon"></i>
          <span>{{ item.name }}</span>
        </template>
        <!-- 递归渲染子菜单 -->
        <side-menu-item :menu-list="item.children" />
      </el-submenu>
      <!-- 否则渲染为 el-menu-item -->
      <el-menu-item v-else :key="item.id" :index="item.path">
        <i :class="item.icon"></i>
          <span slot="title">{{ item.name }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
import SideMenuItem from './SideMenuItem.vue'

export default {
  name: 'SideMenu',
  components: { SideMenuItem },
  props: {
    menuTree: {
      type: Array,
      default: () => []
    }
  }
}
</script>